import { EntraGroupsCollection, Project } from 'src/app/models/project';

export interface ProjectEntraGroup {
  groupObjectId: string;
  groupName?: string;
}

function normalizeEntraGroupMap(entraGroupMap?: Record<string, string> | null): ProjectEntraGroup[] {
  if (!entraGroupMap || typeof entraGroupMap !== 'object') {
    return [];
  }

  return Object.entries(entraGroupMap)
    .filter(([groupObjectId]) => !!groupObjectId)
    .map(([groupObjectId, groupName]) => ({
      groupObjectId,
      groupName: String(groupName ?? '').trim() || undefined,
    }));
}

function normalizeEntraGroupsCollection(
  entraGroups?: EntraGroupsCollection | null
): ProjectEntraGroup[] {
  if (!entraGroups) {
    return [];
  }

  if (Array.isArray(entraGroups)) {
    return entraGroups.flatMap((groupMap) => normalizeEntraGroupMap(groupMap));
  }

  return normalizeEntraGroupMap(entraGroups);
}

export function normalizeProjectEntraGroups(
  project?: Pick<Project, 'entraGroupIds' | 'entraGroups'> | null
): ProjectEntraGroup[] {
  const normalizedGroups = normalizeEntraGroupsCollection(project?.entraGroups);
  const byId = new Map<string, ProjectEntraGroup>();

  normalizedGroups.forEach((group) => {
    byId.set(group.groupObjectId.toLowerCase(), group);
  });

  (project?.entraGroupIds ?? []).forEach((groupObjectId) => {
    const normalizedGroupObjectId = String(groupObjectId ?? '').trim();
    if (!normalizedGroupObjectId) {
      return;
    }

    const lookupKey = normalizedGroupObjectId.toLowerCase();
    if (!byId.has(lookupKey)) {
      byId.set(lookupKey, { groupObjectId: normalizedGroupObjectId });
    }
  });

  return Array.from(byId.values());
}